var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1555_13224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19586 3.17822L19.3695 18.0219L5.26391 32.9951C4.85228 32.7214 4.63161 32.1272 4.62788 31.3595C4.6208 29.8884 4.5085 6.536 4.50004 4.78388C4.49611 3.94351 4.78757 3.43071 5.19586 3.17822ZM24.0441 13.0608L6.80878 3.19844C6.62469 3.09282 6.41562 3.02867 6.20735 3L19.9564 17.3996L24.0441 13.0608ZM24.8096 22.4828L20.5461 18.0178L24.8053 13.4968L30.6708 16.8525C32.1158 17.6788 31.3768 18.7127 30.6708 19.1181L24.8096 22.4828ZM6.43237 33C6.55254 32.9526 6.67802 32.8921 6.80821 32.8175L24.0471 22.9207L19.96 18.6404L6.43237 33Z",
    fill: "#3AB100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1555_13224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.7021114dd97117ad776dc472a59aa1ce.svg";
export { ForwardRef as ReactComponent };